import { Env } from "../../../env";
import { html } from "lit-html";
import { TonerJsEnv } from "../../../models/toner/toner_js_env";
import { MakerPulldownArea, PrinterModelPulldownArea, PrinterTypePulldownArea } from "./toners";
import { encodeString } from "../../../util/browser_util";
import { isSoloare } from "../../../models/js_env";

const TONER_ITEM_ICONS = Env.SETTING.tonerIcons;
const BASE_URL = window.location.protocol + '//' + window.location.host + '/';

export const TonerArea = (model: TonerJsEnv) => html`
<div class="o-menuBar_tonerink a-box -narrow -information">
  <p class="o-menuBar_heading">トナー・インク検索</p>
  ${MakerPulldownArea(model)}
  ${PrinterTypePulldownArea(model)}
  ${PrinterModelPulldownArea(model)}
  <button class="m-btn -auto-16 -small" type="button"
    .disabled="${model.selectedPrinterMaker === '' ||
                 model.selectedPrinterType === null || model.selectedPrinterType === 0}"
    @click="${() => document.location.href = BASE_URL + creatUrl(model)}">
    <span class="m-btn_inner">
      <span class="m-btn_text">検索</span>
    </span>
  </button>
</div>
`;

const creatUrl = (model: TonerJsEnv) => {
  // ソロアリの場合はヘッダーからのトナー検索と合わせて二重エンコードにする
  const printerType = isSoloare(Env.SITE_TYPE)
    ? encodeString(model.selectedPrinterMaker)
    : model.selectedPrinterMaker;
  const printerModel = isSoloare(Env.SITE_TYPE)
    ? encodeString(model.selectedPrinterModel)
    : model.selectedPrinterModel;
  let url: string = `ksearch/?` +
    `printerMaker=${encodeString(printerType)}&` +
    `printerType=${model.selectedPrinterType}&` +
    `printerModel=${encodeString(printerModel)}&`;

  TONER_ITEM_ICONS.forEach(tonerIcon => {
    url += `tonerInkIcon=${tonerIcon}&`;
  });

  url += `callBackKbn=FTR` + window.location.pathname;

  return url;
}
